import { JsonObject, JsonProperty } from 'json2typescript';
import { MaxLength, Required } from '@hvlng/framework-bff/core';
import { HvlLocalizedModel } from 'infrastructure-shared';

@JsonObject('KovanHrTextModel')
export class TextModel extends HvlLocalizedModel {
    @Required()
    @MaxLength(50)
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @Required()
    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText: string = null;
}
